/* eslint-disable no-case-declarations */
import { actions } from 'store/actions/appActions';
import constants from 'constants';

import u from 'updeep';

const initialState = {
  theme: constants.THEME.LIGHT,
  messages: [],
  clientAuthorized: false,
  checkingAuthorized: false,
};

const appReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.SET_THEME:
      return u({ theme: action.payload }, state);

    case actions.ADD_MESSAGE:
      return u({
        messages: action.meta.clearExisting
          ? [ ...action.payload ]
          : [ ...state.messages, ...action.payload ],
      }, state);

    case actions.REMOVE_MESSAGE:
      const messages = state.messages.filter(
        (_, index) => index !== action.payload,
      );
      return u({ messages }, state);

    case actions.CLEAR_MESSAGES:
      return u({ messages: [] }, state);

    case actions.SET_CLIENT_AUTHORIZED:
      return u({ clientAuthorized: action.payload }, state);

    case actions.SET_CHECKING_AUTHORIZED:
      return u({ checkingAuthorized: action.payload }, state);

    default:
      return state;
  }
};

export { appReducer };